import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

// Models
import Opportunity from '../../../../../models/v2/opportunity';

// Base
import Button from '../../../base/button';
import Col from '../../../base/col';
import Row from '../../../base/row';

// Related Components
import Listing from './jobs/listing';
import Loading from './jobs/loading';
import LoadingListing from './jobs/listing/loading';

export default class Jobs extends React.Component {
  static PER_PAGE = 10;

  static propTypes = {
    user: PropTypes.object.isRequired,
  }

  state = {
    initializing: true,
    nextPage: 1,
    opportunities: [],
  }

  componentDidMount() {
    this.loadOpportunities();
  }

  resetAndLoadOpportunities = () => {
    this.setState({
      opportunities: [],
      nextPage: 1,
    }, () => {
      this.loadOpportunities();
    })
  }

  loadOpportunities = () => {
    const { user } = this.props;
    const { opportunities, nextPage } = this.state;

    this.setState({
      loading: true,
    }, () => {
      Opportunity
        .perPage(Jobs.PER_PAGE)
        .page(nextPage)
        .where({
          client_request_assigned_agent_id_eq: user.id,
        })
        .sort('created_at desc')
        .all()
        .then((response) => {
          let newOpportunities;
          if (nextPage === 1) {
            newOpportunities = response.results;
          } else {
            newOpportunities = update(opportunities, { $push: response.results});
          }

          this.setState({
            opportunities: newOpportunities,
            nextPage: response.nextPage,
            initializing: false,
            loading: false,
          })
        })
    });
  }

  render() {
    const { initializing, loading, opportunities, nextPage } = this.state;

    if (initializing) {
      return <Loading />
    }

    return (
      <div className='fixed-width-layout margin-top-20'>
        <div className='full-width-content'>
          <Row nested>
            <Col s={12} className='dark med-font margin-bottom-10'>
              Jobs
            </Col>
            {
              opportunities.map((opportunity) => (
                <Col s={12} key={opportunity.id}>
                  <Listing opportunity={opportunity} />
                </Col>
              ))
            }
            {
              loading &&
              [...Array(Jobs.PER_PAGE)].map((_, i) => (
                <Col s={12} key={i}>
                  <LoadingListing />
                </Col>
              ))
            }
            {
              (nextPage && !loading) &&
              <Col s={12} className='right-align'>
                <Button
                  onClick={this.loadOpportunities}
                >Load More</Button>
              </Col>
            }
          </Row>
        </div>
      </div>
    );
  }
}